(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["shadow-size-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    const mount = () => document.querySelectorAll('[data-shadow-size-guide]').forEach(dialog => {
      if (dialog.dataset.initialized || typeof dialog.showModal !== 'function') return;
      dialog.dataset.initialized = 'true';
      const product = dialog.closest('[data-shadow-product]');
      if (!product) return;
      let opener;
      product.addEventListener('click', event => {
        const trigger = event.target.closest('[data-size-guide-open]');
        if (!trigger || trigger.dataset.sizeGuideOpen !== dialog.id) return;
        event.preventDefault();
        opener = trigger;
        if (!dialog.open) dialog.showModal();
      });
      dialog.querySelector('[data-size-guide-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('close', () => {
        if (opener?.isConnected) opener.focus({preventScroll: true});
      });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) dialog.close();
      });
      dialog.querySelectorAll('[data-size-unit]').forEach(button => button.addEventListener('click', () => {
        const unit = button.dataset.sizeUnit;
        dialog.querySelectorAll('[data-size-unit]').forEach(item => item.setAttribute('aria-pressed', String(item.dataset.sizeUnit === unit)));
        dialog.querySelectorAll('[data-size-panel]').forEach(panel => { panel.hidden = panel.dataset.sizePanel !== unit; });
      }));
    });
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
    else mount();
    document.addEventListener('shopify:section:load', mount);
  })();
  } catch(e) { console.error(e); }
})();

})();
